import PageEdit from './PageEdit';
export default PageEdit;